module.exports = __webpack_public_path__ + "static/media/navigate-icon-left.c97fbc4a.svg";